import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InlineIconText = _ref => {
  let {
    beforeIcon,
    afterIcon,
    children,
    textClassName
  } = _ref;
  if (!beforeIcon && !afterIcon) {
    return /*#__PURE__*/_jsx("span", {
      className: textClassName,
      children: children
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    className: styles['nowrap'],
    children: [beforeIcon, "\u2060", /*#__PURE__*/_jsx("span", {
      className: clsx(styles['wrap'], textClassName),
      children: children
    }), "\u2060", afterIcon]
  });
};